import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { ISiteState } from 'features/site/siteSlice';
import {
  deleteSection,
  ISection,
  patchSection,
  postSection,
} from './sectionAPI';

export const postSectionAsync = createAsyncThunk(
  'section/postSectionData',
  async (
    {
      data,
    }: {
      data: ISection;
    },
    thunkAPI,
  ) => {
    try {
      return { response: await postSection(data) };
    } catch (error: any) {
      return thunkAPI.rejectWithValue({ response: error });
    }
  },
);

export const patchSectionAsync = createAsyncThunk(
  'section/patchSectionData',
  async (
    {
      data,
    }: {
      data: ISection;
    },
    thunkAPI,
  ) => {
    try {
      const res = { response: await patchSection(data) };
      return res;
    } catch (error: any) {
      return thunkAPI.rejectWithValue({ response: error });
    }
  },
);

export const deleteSectionAsync = createAsyncThunk(
  'section/deleteSection',
  async (
    {
      id,
      pageId,
    }: {
      id: number;
      pageId: number;
    },
    thunkAPI,
  ) => {
    try {
      const response = await deleteSection(id);
      return {
        response,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue({ response: error });
    }
  },
);

export function addSectionCases(builder: ActionReducerMapBuilder<ISiteState>) {
  builder
    .addCase(postSectionAsync.pending, (state, action) => {
      state.status = 'loading';
      state.errors = action.payload;
    })
    .addCase(postSectionAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      const id = action.payload.response.data._id;
      const page = state.pages.find(
        (m) => m.id === action.meta.arg.data.page?.id,
      );
      if (page) {
        const data = { ...action.meta.arg.data, id } as ISection;
        page.sections?.push(data);
      }
    })
    .addCase(postSectionAsync.rejected, (state, action) => {
      state.status = 'failed';
      state.errors = action.payload;
    })
    .addCase(patchSectionAsync.pending, (state, action) => {
      state.status = 'loading';
      state.errors = action.payload;
    })
    .addCase(patchSectionAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      const page = state.pages.find((p) =>
        p.sections?.some((s) => s.id === action.meta.arg.data.id),
      );
      if (page && page.sections) {
        const section = page.sections.find(
          (s) => s.id === action.meta.arg.data.id,
        );
        if (section) {
          Object.assign(section, {
            ...section,
            ...action.meta.arg.data,
          });
        }
      }
    })
    .addCase(patchSectionAsync.rejected, (state, action) => {
      state.status = 'failed';
      state.errors = action.payload;
    })
    .addCase(deleteSectionAsync.pending, (state, action) => {
      state.status = 'loading';
      state.errors = action.payload;
    })
    .addCase(deleteSectionAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      const page = state.pages.find((m) => m.id === action.meta.arg.pageId);
      if (page) {
        page.sections = page.sections?.filter(
          (i) => i.id !== action.meta.arg.id,
        );
      }
    })
    .addCase(deleteSectionAsync.rejected, (state, action) => {
      state.status = 'failed';
      state.errors = action.payload;
    });
}
